import { AwsRum, AwsRumConfig } from 'aws-rum-web';

let rumClient: AwsRum | null = null;

export function initRum(): void {
    const appMonitorId = process.env.REACT_APP_RUM_APP_MONITOR_ID;
    const region = process.env.REACT_APP_RUM_REGION;

    if (!appMonitorId || !region) {
        return;
    }

    const config: AwsRumConfig = {
        sessionSampleRate: 1,
        endpoint: `https://dataplane.rum.${region}.amazonaws.com`,
        telemetries: [
            'performance',
            'errors',
            ['http', { addXRayTraceIdHeader: false }],
        ],
        allowCookies: true,
        enableXRay: false,
        signing: false,
    };

    try {
        rumClient = new AwsRum(appMonitorId, '1.0.0', region, config);
    } catch {
        // RUM initialisation failure must never break the app
    }
}

export function recordRumEvent(eventType: string, eventData: object): void {
    try {
        rumClient?.recordEvent(eventType, eventData);
    } catch {
        // silent
    }
}

export function getRumClient(): AwsRum | null {
    return rumClient;
}
